<div class="profile__wrapper">
  <app-table
    [content]="tableOfficeData"
    [headers]="tableOfficeHeaders"
    [tableType]="'material-plus'"
    [showEditFields]="true"
    (rowAction)="addNewOffice()"
  ></app-table>
</div>
